var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
var CustomToggle = React.forwardRef(function (props, ref) {
    var children = props.children, onClick = props.onClick;
    function handleClick(e) {
        e.preventDefault();
        onClick(e);
    }
    return (_jsxs("a", __assign({ onClick: handleClick, className: "", style: {}, ref: ref }, { children: [_jsx("i", { className: "fa fa-ellipsis-h" }), children] })));
});
var TaskDropdownButton = function (_a) {
    var disabled = _a.disabled, menuItems = _a.menuItems;
    return (_jsxs(Dropdown, __assign({ pullRight: true, id: "task-dropdown-button" }, { children: [_jsx(CustomToggle, { bsRole: "toggle" }), _jsx(Dropdown.Menu, { children: menuItems.map(function (menuItem) { return (_jsx(MenuItem, __assign({ onSelect: menuItem.onSelect, disabled: disabled }, { children: _jsxs(_Fragment, { children: [menuItem.icon, " ", menuItem.title] }) }), menuItem.title)); }) })] })));
};
export default TaskDropdownButton;
